import { ProfileTypeRequests } from '@/services/profile-type.requests'
const profileTypeService = new ProfileTypeRequests()

const state = {
  list: []
}
const getters = {}

const actions = {
  list ({ state }) {
    return new Promise((resolve, reject) => {
      profileTypeService.list().then(async (profileTypes) => {
        state.list = profileTypes
        resolve(profileTypes)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
